export default {
  // 首页拼团列表
  groupList: [],
  // 拼团商详
  groupInfo: {},
  // 其他拼团列表
  otherGroupsList: []
}
